import { AlertTriangleIcon, CircleAlertIcon, CircleCheckIcon, InfoIcon } from 'lucide-react';

export type Variants = keyof typeof IconsByState;

export const IconsByState = {
  neutral: <InfoIcon size={16} className="text-foreground" />,
  success: <CircleCheckIcon size={16} className="text-green-600" />,
  info: <InfoIcon size={16} className="text-foreground-muted" />,
  warning: <CircleAlertIcon size={16} className="text-yellow-600" />,
  attention: <CircleAlertIcon size={16} className="text-orange-600" />,
  critical: <AlertTriangleIcon size={16} className="text-red-600" />,
} as const;
